var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._ssrNode("<div"+(_vm._ssrClass(null,_vm.classes))+(_vm._ssrStyle(null,_vm.styles, null))+">","</div>",[_vm._t("default")],2),_vm._ssrNode(" <div"+(_vm._ssrStyle(null,_vm.slotStyle, { display: (_vm.slot) ? '' : 'none' }))+"></div>")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a70eba08","hasScoped":false,"optionsId":"1","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/module/affix/affix.vue
// module id = 547
// module chunks = 0 1 57